










































//Component
// import InputGroup from "./InputGroup.vue";
import Popover, { PopoverProps } from "./Popover.vue";
import Table from "@/components/Table.vue";
import Select from "@/components/Select.vue";
import ExpirationTimeSelector from "@/components/ExpirationTimeSelector.vue";

//Composables
import useCancelButton from "@/composables/buttons/useCancelButton";
import useAssociateButton from "@/composables/buttons/useAssociateButton";

//Models
// import IButton from "@/interfaces/IButton";
import {
  computed,
  defineComponent,
  // Ref,
  ref,
  watch,
} from "@vue/composition-api";

import { Organization, useOrganizationsSearchQuery } from "@/graphql/types";
import { useResult } from "@vue/apollo-composable";

export default defineComponent({
  components: { Popover, Table, Select, ExpirationTimeSelector },
  props: {
    ...PopoverProps,
  },
  setup(_, { root, emit }) {
    const show = ref(false);
    const filters = ref("");

    var primaryClick: (() => void) | null = null;
    var secondaryClick: (() => void) | null = null;

    const { result, loading } = useOrganizationsSearchQuery(
      () => ({ input: filters.value }),
      () => ({
        enabled: (filters.value ?? "")?.length >= 3,
        fetchPolicy: "no-cache",
      })
    );

    const selectableOrganizations = useResult(
      result,
      [],
      (data) => data.organizationSearch.nodes
    );

    const templateResult = (option: any) => {
      let html = "";
      html += "<div>" + option?.object?.name + "</div>";
      html += "<small>" + option?.object?.vat + "</small>";
      return html;
    };

    const selectedOrganization = ref<Organization | null>(null);
    const organization = computed<Organization | null>({
      get(): Organization | null {
        return null;
      },
      set(newValue: Organization | null) {
        selectedOrganization.value = newValue;
      },
    });

    const associate = (): Promise<Organization | null> => {
      show.value = true;
      return new Promise((resolve) => {
        primaryClick = () => {
          resolve(selectedOrganization.value);
          show.value = false;
        };
        secondaryClick = () => {
          resolve(selectedOrganization.value);
          show.value = false;
        };
      });
    };

    watch(
      () => show.value,
      (newValue) => {
        if (!newValue) {
          selectedOrganization.value = null;
        }
      }
    );

    return {
      show,
      filters,
      loading,
      associate,
      organization,
      templateResult,
      selectableOrganizations,
      primaryButton: useAssociateButton(() => {
        if (primaryClick) {
          primaryClick();
        }
      }),
      secondaryButton: useCancelButton(() => {
        if (secondaryClick) {
          secondaryClick();
        }
      }),
    };
  },
});
